import { useIntl } from 'react-intl';

import Image from '@/components/image/NextImage';

import { Attribution, AttributionWrapper, MemberSince, Photo, Quote, TestimonialWrapper } from './styles';
import { Stat } from './types';

const Testimonial = ({ quote, quoteName, quoteDescription, quotePhoto }: Omit<Stat, 'stat'>) => {
	const { formatMessage } = useIntl();
	return (
		<TestimonialWrapper>
			<Quote>{formatMessage(quote)}</Quote>
			<Photo>
				<Image alt="" src={quotePhoto} width={48} height={48} />
			</Photo>
			<AttributionWrapper>
				<Attribution>{formatMessage(quoteName)}</Attribution>
				<MemberSince>{formatMessage(quoteDescription)}</MemberSince>
			</AttributionWrapper>
		</TestimonialWrapper>
	);
};

export default Testimonial;
